module.exports = __webpack_public_path__ + "img/as_con3_img.0f7ba95f.png";